import { Box } from '@material-ui/core';
import React from 'react';
import { AboutPageTab } from '../../../containers/AboutPage/aboutPageUtils';
import { TerraColor } from '../../../containers/AdminPage/terra/util/theme';
import IconTreetLogo from '../../Icons/IconTreetLogo/IconTreetLogo';
import NamedLink from '../../NamedLink/NamedLink';
import TypographyWrapper, { TypographyFormat } from '../../TypographyWrapper/TypographyWrapper';
import css from '../Footer.module.css';

export const PoweredByTreetSection = () => {
  const textColor = TerraColor.Gray80;
  const logoColor = TerraColor.Gray80;
  const separatorColor = TerraColor.Gray40;

  return (
    <Box className={css.poweredBySection}>
      <p
        style={{
          color: textColor,
        }}
      >
        Powered by <IconTreetLogo className={css.poweredByIcon} altText="Treet" color={logoColor} />{' '}
        branded resale
      </p>
      <div className={css.poweredBySeparator} role="separator" style={{ color: separatorColor }}>
        |
      </div>
      <NamedLink
        name="AboutPage"
        params={{ tab: AboutPageTab.AboutTreet }}
        className={css.poweredByAboutLink}
      >
        <p
          style={{
            color: textColor,
          }}
        >
          About Treet
        </p>
      </NamedLink>
    </Box>
  );
};
